import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Person',
    field: 'personId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'personId',
      fk: 'personId',
      namespace: 'person',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Committee',
    field: 'committeeId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'committeeId',
      fk: 'committeeId',
      namespace: 'committee',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
